<script setup>
import { ref, onMounted, computed, watch } from "vue";
import { useRequestsStore } from "@/stores/storeRequests";
import { useSettingsStore } from "@/stores/storeSettings";
import { useModals } from "@/composables/useModals";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/navigation";
import { Scrollbar } from "swiper/modules";
import SliderScrollBar from "@/components/blocks/slider/SliderScrollBar.vue";
import SliderSlide from "@/components/blocks/slider/SliderSlide.vue";
import ProfileEmpty from "@/components/profile/ProfileEmpty.vue";

const storeRequests = useRequestsStore();
const storeSettings = useSettingsStore();
const { openModal } = useModals();

const listPointsPrizes = ref([]);

const formatListPointsPrizes = computed(() => {
	return listPointsPrizes.value.map((prize) => {
		return {
			...prize,
			disabled: storeRequests.userData?.points_balance < prize.points
		}
	}).sort((a, b) => a.points - b.points);	
})

const moduleBrackboints = {

	320: {
		slidesPerView: 2.1,
		spaceBetween: 10,
	},
	376: {
		slidesPerView: 2.1,
		spaceBetween: 17,
	},
	481: {
		slidesPerView: 2.3,
		spaceBetween: 20,
	},
	577: {
		slidesPerView: 3,
		spaceBetween: 20,
	},
	769: {
		slidesPerView: 4,
		spaceBetween: 20,
	},
	993: {
		slidesPerView: 3,
		spaceBetween: 20,
	},
	1201: {
		slidesPerView: 5,
		spaceBetween: 28,
	},
}
const isMobile = computed(() => storeSettings.widthWindow <= 1024);

const info = (prize) => {
	openModal("modalPrize", { content: prize, size: "w585" });
};
const exchange = (prize) => {
	openModal("modalExchange", { content: prize, size: "w740" });
};

onMounted(async () => {
	listPointsPrizes.value = await storeRequests.getPrizes('point', 'available_only'); // available_only
	
});
</script>
<template>
	<div class="user-prizes">
		<h2 class="user-prizes__title profile-title">Витрина подарков</h2>
		<div class="user-prizes__slider" v-if="listPointsPrizes.length">
			<SliderScrollBar class="user-prizes__scrollbar case-scrollbar" />
			<Swiper
				:modules="[Scrollbar]"
				:observer="true"
				:observeParents="true"
				:observeSlideChildren="true"
				:resizeObserver="true"
				:scrollbar="{
					el: '.case-scrollbar',
					draggable: true,
				}"
				:breakpoints="moduleBrackboints"
				class="user-prizes__swiper"
			>
				<SwiperSlide :class="['prizes-slide']" v-for="prize in formatListPointsPrizes" :key="prize.id">
					<SliderSlide :disabled="prize.disabled" :isShowExchange="true" :prize @info="info" @exchange="exchange" title-btn="Выбрать подарок" />
				</SwiperSlide>
			</Swiper>
		</div>
		<ProfileEmpty :active-btn="false" v-else>Витрина подарков пока что пуста.</ProfileEmpty>
	</div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";

.user-prizes {
	&__title {
		margin-bottom: 37px;
	}

	&__slider {
	}

	&__scrollbar {
		margin-bottom: 37px;
	}

	&__swiper {
		// overflow: unset;
		@media (max-width: vars.$l) {
			padding-right: var(--padding-container);
			margin-right: calc(var(--padding-container) * -1);
		}
	}
}
.prizes-slide {
	height: auto;
}

</style>
